import { CustomerPermissionCodes, UserPermissionCodes } from "@odata/CompanyPermissionEnums";
import React, { lazy } from "react";

import {
    AUDIT_TRAIL,
    ROUTE_INBOX,
    ROUTE_INBOX_CUSTOMER_APPROVAL,
    ROUTE_INBOX_SEND_TO_ACCOUNTANT,
    ROUTE_INBOX_SETTINGS
} from "../routes";
import PrivateRoute from "../routes/PrivateRoute";

const InboxItemLog = lazy(() => import(/* webpackChunkName: "inbox" */"../pages/inbox/InboxItemLog"));
const Inbox = lazy(() => import(/* webpackChunkName: "inbox" */"../pages/inbox/Inbox"));
const InboxCustomerApproval = lazy(() => import(/* webpackChunkName: "inbox" */"../pages/inbox/InboxCustomerApproval"));
const InboxCustomerItemLog = lazy(() => import(/* webpackChunkName: "inbox" */"../pages/inbox/InboxCustomerItemLog"));
const InboxSendToAccountant = lazy(() => import(/* webpackChunkName: "inbox" */"../pages/inbox/InboxSendToAccountant"));
const InboxFileActionLog = lazy(() => import(/* webpackChunkName: "inbox" */"../pages/inbox/InboxFileActionLog"));
const InboxSettings = lazy(() => import(/* webpackChunkName: "inbox" */"../pages/inboxSettings/InboxSettings"));

export default function inboxBundle(): React.ReactElement[] {
    return [
        <PrivateRoute
                path={`${ROUTE_INBOX}/${AUDIT_TRAIL}`}
                key={`${ROUTE_INBOX}/${AUDIT_TRAIL}`}
                CPs={[UserPermissionCodes.InBox, UserPermissionCodes.Audit]}
                allowReadonlyPermissionBypass={false}
                component={InboxItemLog}/>,
        <PrivateRoute
                path={`${ROUTE_INBOX}/:folder?`}
                key={`${ROUTE_INBOX}/:folder?`}
                CPs={[UserPermissionCodes.InBox]}
                allowReadonlyPermissionBypass={false}
                component={Inbox}/>,
        <PrivateRoute
                exact
                path={ROUTE_INBOX_CUSTOMER_APPROVAL}
                key={ROUTE_INBOX_CUSTOMER_APPROVAL}
                CPs={[UserPermissionCodes.InBox, CustomerPermissionCodes.DocumentApproval]}
                allowReadonlyPermissionBypass={false}
                component={InboxCustomerApproval}/>,
        <PrivateRoute
                path={`${ROUTE_INBOX_CUSTOMER_APPROVAL}/${AUDIT_TRAIL}`}
                key={`${ROUTE_INBOX_CUSTOMER_APPROVAL}/${AUDIT_TRAIL}`}
                CPs={[UserPermissionCodes.InBox, CustomerPermissionCodes.DocumentApproval, UserPermissionCodes.Audit]}
                allowReadonlyPermissionBypass={false}
                component={InboxCustomerItemLog}/>,
        <PrivateRoute exact
                      path={ROUTE_INBOX_SEND_TO_ACCOUNTANT}
                      key={ROUTE_INBOX_SEND_TO_ACCOUNTANT}
                      CPs={[UserPermissionCodes.InBox, UserPermissionCodes.CustomerPortal, CustomerPermissionCodes.ChatInteractWithAccountant]}
                      allowReadonlyPermissionBypass={false}
                      component={InboxSendToAccountant}/>,
        <PrivateRoute
                path={`${ROUTE_INBOX_SEND_TO_ACCOUNTANT}/${AUDIT_TRAIL}`}
                key={`${ROUTE_INBOX_SEND_TO_ACCOUNTANT}/${AUDIT_TRAIL}`}
                CPs={[UserPermissionCodes.InBox, UserPermissionCodes.CustomerPortal, UserPermissionCodes.Audit, CustomerPermissionCodes.ChatInteractWithAccountant]}
                allowReadonlyPermissionBypass={false}
                component={InboxFileActionLog}/>,

        <PrivateRoute
                path={ROUTE_INBOX_SETTINGS}
                key={ROUTE_INBOX_SETTINGS}
                CPs={UserPermissionCodes.MasterData}
                allowReadonlyPermissionBypass={false}
                component={InboxSettings}/>
    ];
}
